import { getFileUrl } from "api/Api";
import AddressField from "./Address";

export const plugins = {
  address: { Component: AddressField },
  FileUploader: { services: { getUrl: getFileUrl } },
};
